import React, {FC} from "react";
import {Card, Col, Form, Row} from "react-bootstrap";
import {Field, useFormikContext} from "formik";
import {FormikInput, FormikRowInput, FormikSelect} from "@components/panel/formik";
import {EGiftType} from "@interfaces/user/daily";
import {FormikItemInput, ItemInput} from "@components/consumer/helpers";
import {FormikRowSelect} from "@components/panel/formik";

interface RewardBlockProps {
    editForm?: boolean;
}

const RewardBlock: FC<RewardBlockProps> = ({editForm}) => {

    const {values, setFieldValue, errors} = useFormikContext<{type: EGiftType, itemId: string}>();

    return (
        <Card className="mb-3">
            <Card.Header as="h6" className="bg-body-tertiary">
                Награда
            </Card.Header>
            <Card.Body>
                <Field
                    label="Тип награды"
                    name="type"
                    disabled={editForm}
                    component={FormikSelect}>
                    <option value={EGiftType.BalanceGift}>Баланс</option>
                    <option value={EGiftType.ItemGift}>Предмет</option>
                </Field>
                {values.type === EGiftType.BalanceGift && (
                    <Field
                        label="Сумма"
                        type="number"
                        name="balance"
                        min={1}
                        max={10000000}
                        placeholder="1-10000000"
                        description="Сумма, которую будет давать подарок"
                        component={FormikInput} />
                )}
                {values.type === EGiftType.ItemGift && (
                    <>
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label>Предмет</Form.Label>
                            </Form.Group>
                            <ItemInput
                                name="itemId"
                                value={values.itemId}
                                setFieldValue={setFieldValue}/>
                            <Form.Control.Feedback type="invalid">{errors.itemId}</Form.Control.Feedback>
                        </Col>
                        <Field
                            label="Количество"
                            name="count"
                            type="number"
                            component={FormikInput}
                        />
                    </>
                )}
            </Card.Body>
        </Card>
    )
}

export default RewardBlock;
